/**
 * @fileoverview Barrel exports for the prose-expander-comparison-v2 agent.
 */

export { definition } from './definition';

export {
  InputSchema,
  OutputSchema,
  HookInputSchema,
  ComparisonItemSchema,
  type Input,
  type Output,
  type HookInput,
  type ComparisonItem,
} from './schema';

export { flow, proseExpanderComparisonV2AgentFlow } from './flow';

